import { RefObject, useEffect } from 'react';

export function useClickOutside(ref: RefObject<HTMLElement | null>, handler: (outside?: boolean) => void) {
  useEffect(() => {
    const detectClickOutside = (evt: MouseEvent) => {
      if (!ref.current) return;
      if (!ref.current.contains(evt.target as Node)) {
        handler(true);
      } else {
        handler(false);
      }
    };

    document.addEventListener('click', detectClickOutside, false);
    return () => document.removeEventListener('click', detectClickOutside, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
